import { render } from "./Feed.vue?vue&type=template&id=d3f4de44&scoped=true"
import script from "./Feed.vue?vue&type=script&lang=js"
export * from "./Feed.vue?vue&type=script&lang=js"

import "./Feed.vue?vue&type=style&index=0&id=d3f4de44&scoped=true&lang=css"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3f4de44"]])

export default __exports__